<div class="custom-item-dialog">
  <div class="custom-item-dialog__header">
    <h3>Add Custom Item</h3>
    <button class="custom-item-dialog__close" (click)="close()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <div class="custom-item-dialog__body">
    <div class="custom-item-dialog__field">
      <label>Price</label>
      <div class="custom-item-dialog__price-input">
        <span>$</span>
        <input type="number" [(ngModel)]="itemPrice" placeholder="0.00" step="0.01"
               inputmode="decimal" cdkFocusInitial (keyup.enter)="submit()"/>
      </div>
    </div>
    <div class="custom-item-dialog__field">
      <label>Item Name <span class="custom-item-dialog__field-hint">(optional)</span></label>
      <input type="text" [(ngModel)]="itemName" placeholder="Custom Item" (keyup.enter)="submit()"/>
    </div>
  </div>

  <div class="custom-item-dialog__actions">
    <button class="custom-item-dialog__cancel" (click)="close()">Cancel</button>
    <button class="custom-item-dialog__submit" [disabled]="isPriceInvalid()" (click)="submit()">
      Add to Cart
    </button>
  </div>
</div>
